<template>
  <div id="data"></div>
</template>

<script>
import { Chart } from '@antv/g2';

export default {
  name: 'orderAmmount',
  props: {
    data: Array,
  },
  mounted() {
    const data = [];
    this.data.map(item => {
      data.push({ date: item.date, type: '订单量', value: item.num });
      data.push({ date: item.date, type: '订单总额', value: item.money });
      data.push({ date: item.date, type: '订单收入', value: item.income });
    });

    const chart = new Chart({
      container: 'data',
      autoFit: true,
      height: 300,
    });
    // G2中宽度自适应问题
    const e = document.createEvent('Event');
    e.initEvent('resize', true, true);
    window.dispatchEvent(e);

    chart.data(data);

    chart.scale('value', { nice: true });

    chart.legend({
      position: 'top',
    });

    chart
      .interval()
      .position('date*value')
      .color('type')
      .adjust([
        {
          type: 'dodge',
          marginRatio: 0,
        },
      ]);

    chart.render();
  },
};
</script>

<style lang="less" scoped>
#data {
  width: 100%;
}
</style>
